/* eslint-disable camelcase */
import axios from 'axios';
import { transformListParams } from 'services/commons/transformers';
import { BASE_PATH_API } from 'constants/env';

async function getProducts(count = 99) {
  const res = await axios({
    url: `https://recommender.scarabresearch.com/merchants/154ED0EBE19AA12E/?f=f:CATEGORY,l:${count},o:0&vc=línea blanca y electrodomésticos`,
  });
  return res.data;
}

async function getProductsById(
  products = [],
  params = {},
  transformed = false
) {
  let res = null;
  const transformedParams = transformListParams(params);

  try {
    res = await axios({
      url: `${BASE_PATH_API}/products/v1/products?filter_by[id]=${products.join(
        ','
      )}`,
      params: transformedParams,
    });
    return transformed ? res.data.data.map(mapProductData) : res.data;
  }
  catch (error) {
    return [];
  }
}

async function getRecommendationsByEventId(eventId) {
  try {
    const recommendations = await axios({
      url: `${BASE_PATH_API}/gift-table/v1/recommendation-product/${eventId}`,
    });
    const res = await getProductsById(
      recommendations.data.data.map((item) => item.product)
    );
    const transformedId = res.data.map((product) => ({
      ...product,
      id: Number(product.id),
    }));
    return transformedId;
  } catch (e) {
    return [];
  }
}

async function getProductsBySku({ sku, seller = 2430 }) {
  try {
    const res = await axios({
      url: `${BASE_PATH_API}/products/v1/products?filter_by[sku]=${sku}&filter_by[seller_id]=${seller}`,
    });
    return res.data.data.map(mapProductData);
  } catch (e) {
    return [];
  }
}

export function decodeHtmlTitle(html) {
  const txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
}

export const mapProductData = (product) => {
  const reviews = String(product.rating.average_score);
  return {
    id: product.id,
    description: product.description,
    item: product.id,
    title: decodeHtmlTitle(product.title),
    image: product.pictures ? product.pictures[0].thumbnail : '',
    msrp: product.pricing?.list_price,
    price: product.pricing?.sales_price,
    c_descuento: product.pricing?.percentage_discount,
    product_id: product.id,
    stock: product.stock,
    review: reviews,
    total_review: product.rating.total_reviews,
    status: product.status || product.is_active,
    categories: product.categories || [],
    seller: product.seller || [],
    variant_id: product.variant_id,
    variant_sku: product.variant_sku,
    sku: product.sku,
    ean: product.ean,
    division: product.division,
    variations: product.variations,
  };
};

const getMapProductWithTableInfo =
  (tableGifts = []) =>
  (product) => {
    const {
      amount = 0,
      gifted,
      is_default,
    } = tableGifts.find((gift) => gift.product_id === product.product_id && gift.variant_id == product.variant_id) || {};
    return {
      ...product,
      amount,
      gifted,
      is_default,
      quantity: amount,
    };
  };

export {
  getProducts,
  getProductsById,
  getRecommendationsByEventId,
  getMapProductWithTableInfo,
  getProductsBySku,
};
